import React from "react";
import "./Footer.css";

const Footer = props => {
	return <div className="Footer">{props.text}</div>;
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js